<payMethod [payMethod]='value' [isEnlarge]='true' [revV]='trigger.menuOpen'
           [matMenuTriggerFor]='menu' #trigger='matMenuTrigger' (click)='trigger.openMenu()'></payMethod>

<!--  === MAT MENU ========================================-->
<mat-menu #menu='matMenu'>
  <payMethod *ngFor='let payMethod of (payS.allMethodsSub$|async)' [payMethod]='payMethod'
             (click)='selectPayMethod(payMethod)' [isBorder]='false' [isHover]='true'></payMethod>
  <button [ngStyle]='(elRef|getWidthMatMenu)' class='hiddenMatOption'></button>
</mat-menu>
